import { makeStyles, } from '@material-ui/core/styles';

export const makeIconWrapperStyles = makeStyles({
    root: {
        display: 'flex',
        marginRight: '0.25rem',
    },
});
